import React, { useContext, useState } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from '../../../../Context/GroupReportContext';
import { initialDataLeaderShip } from '../groupReport-pdf/QuadrantInFocus';

const styles = {
  container: { paddingTop: '16px' },
  heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#426B88", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
  description: { marginBottom: "16px", color: "#000000", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px' },
  tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "6px" },
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight: "13px", },
  th: { padding: "0 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight: "13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
  td: { borderLeft: "0.67px solid #ddd", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },
  heartColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none" },
  rowEven: { backgroundColor: "#FFF" },
  rowOdd: { backgroundColor: "#F1F3F3" },
  rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
  rectangle: { width: "16px", height: "16px", backgroundColor: "#B6111F", borderRadius: "1.34px" }
};

export default function CollabrativeInFocus({ apiData, pageNumber }) {
  const groupReportCtx = useContext(GroupReportContext)

  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);

  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index + 1 < full + 1) {
      // Full square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial square (only red part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#B6111F',
            borderRadius: '1.34px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };


  const questions = [
    { id: 1, question: "When leading through conflict, I am attuned to the feelings everyone is experiencing.", variableBase: "ls1" },
    { id: 2, question: "I am at my best when I feel more deeply connected to others.", variableBase: "ls2" },
    { id: 3, question: "I want to build an emotionally intelligent organization.", variableBase: "ls3" },
    { id: 4, question: "I believe relationships of trust are essential to create a successful organization.", variableBase: "ls4" },
    { id: 5, question: "I believe developing a healthy culture is a very high value of my leadership.", variableBase: "ls5" },
    { id: 6, question: "I am motivated to help my team connect more deeply with each other.", variableBase: "ls6" },
    { id: 7, question: "I find satisfaction from developing a collaborative leadership culture.", variableBase: "ls7" },
    { id: 8, question: "I develop others by gaining buy-in around shared values.", variableBase: "ls8" },
    { id: 9, question: "I enjoy building an empowering culture at work.", variableBase: "ls9" },
    { id: 10, question: "I want our people to be fully engaged in the decision-making process.", variableBase: "ls10" }
  ];

  const displayData = dynamicData?.filter((el) => el.quadrant == "COLLABORATIVE");
  const allVariableSets = [apiData?.variables]

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // // console.log(el.quadrant, quadrantScores?.[el.quadrant])
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, index + 1, "in_focus");
    if (res?.averageScore !== null && quadrantScores?.[el.quadrant] == 4) {
      allResults.push(res);
    }
  })

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div style={styles.container}>
        <h1 style={styles.heading}>COLLABORATIVE LEADERSHIP IN FOCUS</h1>
        <p style={styles.description}>
This chart isolates the items related to Collaborative Leadership based on the combined ratings of participants. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.        </p>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.heartColumn }}>Collaborative</th>
                <th style={{ ...styles.th }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} style={styles.th}>
                    {num}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = parseInt(allResults[index]?.averageScore);
                return (
                  <tr
                    key={index}
                    style={(index % 2) === 0 ? styles.rowOdd : styles.rowEven}
                  >
                    <td style={{ ...styles.td, ...styles.heartColumn }}>
                      {item.question}
                    </td>
                    <td style={{ ...styles.td }}> {parseFloat(avgScore) > 0 ? avgScore : "-"} </td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} />
    </div>
  );
}
